module.exports = __webpack_public_path__ + "69c1788207d29fa5f89c8b3de6a51f8e.jpg";